import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { EntityPickerPopover } from '@work4all/components/lib/components/entity-picker/components';
import {
  IReport2PickerProps,
  Report2Picker,
} from '@work4all/components/lib/components/entity-picker/report2-picker/Report2Picker';

import { PickerTargetButton } from '../../containers/mask-overlays/locked-inputs';

interface Report2PickerFieldProps
  extends Omit<IReport2PickerProps<false>, 'multiple'> {
  error?: string;
  name?: string;
}

export const Report2PickerField = React.forwardRef<
  HTMLDivElement,
  Report2PickerFieldProps
>(function Report2PickerField(props, ref) {
  const { error, ...pickerProps } = props;
  const { value, onChange } = pickerProps;

  const { t } = useTranslation();

  const popoverRef = useRef<EntityPickerPopover>(null);

  return (
    <EntityPickerPopover
      ref={popoverRef}
      picker={<Report2Picker {...pickerProps} multiple={false} />}
    >
      <PickerTargetButton
        ref={ref}
        value={value ? value?.name : ''}
        name={props.name}
        label={t('FIELDS.report')}
        error={error}
        onClear={() => {
          onChange(null);
        }}
      />
    </EntityPickerPopover>
  );
});
